import React from 'react';
import { connectStateResults } from 'react-instantsearch-dom';

const SearchTitle = ({ searchState }) => {
    if (searchState.query.length > 0) {
        return (
            <h1 className="search-title"><span>Search result for</span> {`"${searchState.query}"`}</h1>
        );
    }
    return (
        <h1 className="search-title">Please enter a search term</h1>
    );
};

export default connectStateResults(SearchTitle);
